import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
  name: 'simpleDate',
  standalone: true,
})
export class SimpleDatePipe implements PipeTransform {
  transform(value: any, dateOnly = false): any {
    if (!value) return;
    if (!dayjs(value).isValid()) return value;

    // Date-only values are stored as UTC midnight; read them in UTC so the day doesn't shift,
    // and skip the time branch since their time component is meaningless.
    if (dateOnly) {
      const date = dayjs.utc(value);
      if (date.isSame(dayjs.utc(), 'year')) return date.format('MMM D');
      return date.format('MMM D, YYYY');
    }

    const date = dayjs(value);

    if (date.isSame(new Date(), 'day')) return date.format('h:mm a');

    if (date.isSame(new Date(), 'year')) return date.format('MMM D');

    return date.format('MMM D, YYYY');
  }
}
